import axios from "axios";
import { MainEndpoints, SessionUpgradeResponse } from "@authory-packages/core";
import { API_URL } from "./index";
import { getHeaders } from "./get-headers";

/**
 * Exchanges an old login token for a session token.
 * @param token The old login token
 * @returns The new session token
 */
export async function upgradeSession(token: string) {
    const { data } = await axios.post<SessionUpgradeResponse>(`${API_URL}${MainEndpoints.SessionUpgrade}`, undefined, getHeaders(token));

    return data;
}

/**
 * Expires the session on the server so the token stops working.
 * @param token The token of the session to end
 */
export async function signOutSession(token: string) {
    await axios.post(`${API_URL}${MainEndpoints.SignOut}`, undefined, getHeaders(token));
}
